import * as React from 'react';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { SelectItem } from '../types';
import { LoadOptions, ButtonTertiary } from 'ui';
import { SelectMultipleHierarchy } from 'app/area/shared/translated-components';
import { ModalSize } from 'app/components/constants';

import type { JSX } from "react";

interface ButtonSelectMultipleDialogComponentProps {
  disabled?: boolean;

  className: string;
  options: SelectItem[];
  placeholder: string;
  textButtonAdd: string;
  textTitle: string;
  textDone: string;
  textConfirm: string;
  textOptionsNotFound: string;
  textPageOf: string;

  onLoadOptions: (query?: string) => void;
  onSelect: (items: SelectItem[]) => void;

  locale: string;
  displaySelectAll?: boolean;
  textSelectAll?: string;
  textClearAll?: string;
  selectedItems?: SelectItem[];
}

interface ButtonSelectMultipleDialogComponentState {
  loadOptions: LoadOptions;
  isOpen: boolean;
  valueItems: SelectItem[];
  fetching: boolean;
}

class ButtonSelectMultipleDialogComponent extends React.Component<
  ButtonSelectMultipleDialogComponentProps,
  ButtonSelectMultipleDialogComponentState> {
  public static defaultProps: Partial<ButtonSelectMultipleDialogComponentProps> = {
    disabled: false
  };
  public state: Readonly<ButtonSelectMultipleDialogComponentState> = {
    loadOptions: {},
    isOpen: false,
    valueItems: [],
    fetching: false
  };

  private onLoadOptions = (loadOptions: LoadOptions) => {
    this.setState({
      loadOptions: { ...loadOptions },
      fetching: true
    } as ButtonSelectMultipleDialogComponentState, () => {
      if (!!loadOptions.query) {
        this.props.onLoadOptions(loadOptions.query);
      } else {
        this.props.onLoadOptions();
      }
    });

  };

  private handleOnChange = (items: SelectItem[]) => {
    this.setState({
      valueItems: items
    } as ButtonSelectMultipleDialogComponentState);
  };

  private handleOpenDialog = (e: React.SyntheticEvent<HTMLDivElement>) => {
    if (!this.props.disabled) {
      this.setState({
        isOpen: true,
        valueItems: this.props.selectedItems || []
      } as ButtonSelectMultipleDialogComponentState);
    }
  };

  private handleOnDone = () => {
    this.props.onSelect([...this.state.valueItems]);
    this.setState({
      valueItems: [],
      isOpen: false
    } as ButtonSelectMultipleDialogComponentState);
  };

  public componentDidUpdate(prevProps: ButtonSelectMultipleDialogComponentProps) {
    if (prevProps.options !== this.props.options) {
      this.setState({
        fetching: false
      });
    }
  }

  private renderDialog = () => {
    const {
      options, locale
    } = this.props;
    const {
      loadOptions
    } = this.state;
    const hideSearchInput = !options.length && !!loadOptions && !loadOptions.query;
    return <ModalWrapper onClose={this.handleOnDone}
      onDone={this.handleOnDone}
      headerTitle={this.props.textTitle}
      btnTitle={this.props.textConfirm}
      size={ModalSize.large}
    >
      <SelectMultipleHierarchy
        componentId="0"
        className="select-single-dialog"
        valueItems={this.state.valueItems}
        onChange={this.handleOnChange}
        loadOptions={this.state.loadOptions}
        onLoadOptions={this.onLoadOptions}
        options={options}
        placeholder={this.props.placeholder}
        leafNodeOnly={true}
        isOpen={true}
        alwaysOpen={true}
        fetching={this.state.fetching}
        longDescription={false}
        hideSearchInput={hideSearchInput}
        descriptionAllLevels={true}
        locale={locale}
        displaySelectAll={!!this.props.displaySelectAll}
        textSelectAll={this.props.textSelectAll}
        textClearAll={this.props.textClearAll}
      />
    </ModalWrapper>;
  };

  public render(): JSX.Element {
    return (<div className={this.props.className}>
      <ButtonTertiary classNames="btn-block" onClick={this.handleOpenDialog} disabled={this.props.disabled}>
        {this.props.textButtonAdd}
      </ButtonTertiary>
      {this.state.isOpen && this.renderDialog()}
    </div>
    );
  }
}

export const ButtonSelectMultipleDialog = ButtonSelectMultipleDialogComponent;
